import React from 'react';
import EmojiPicker, { EmojiPickerPopOver } from '../../components/EmojiPicker';
import OverflowMenu from '../../components/OverflowMenu';

interface CommentMenuProps {
  emojiPickerOpen: boolean;
  onEmojiPickerOpenChange: (open: boolean) => void;
  toggleCommentReaction: (emoji: string) => void;
  menuItems: React.ReactNode;
}

const CommentMenu = ({
  emojiPickerOpen,
  onEmojiPickerOpenChange,
  toggleCommentReaction,
  menuItems,
}: CommentMenuProps) => (
  <>
    <OverflowMenu buttonSize="lg">{menuItems}</OverflowMenu>
    <EmojiPickerPopOver
      open={emojiPickerOpen}
      setOpen={onEmojiPickerOpenChange}
    >
      <EmojiPicker
        onPick={(emoji) => {
          onEmojiPickerOpenChange(false);
          toggleCommentReaction(emoji);
        }}
      />
    </EmojiPickerPopOver>
  </>
);

export default CommentMenu;
